import LocalizedStrings from 'react-localization';
import no from 'languages/no';
import nn from 'languages/nn';

const baseContent = {no, nn};

const strings = new LocalizedStrings(baseContent);

// Apply super-admin key/value overrides fetched from the backend on top of the
// bundled dictionaries. no.js and nn.js are FLAT (key -> string) — unlike the se
// branch's nested namespaces — so each override key maps directly onto the
// top-level of its locale. We rebuild every locale so removed overrides revert
// to the bundled default.
export const applyOverrides = (overrides = {}) => {
	const currentLang = strings.getLanguage();
	const merged = Object.keys(baseContent).reduce((acc, locale) => {
		const {_meta, ...localeOverrides} = overrides[locale] || {};
		acc[locale] = {...baseContent[locale], ...localeOverrides};
		return acc;
	}, {});
	strings.setContent(merged);
	if (currentLang) strings.setLanguage(currentLang);
};

const LANG_CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes

export function langCacheKey(app) {
	return `lang_config_${app}`;
}

export function readLangCache(app) {
	try {
		const raw = localStorage.getItem(langCacheKey(app));
		if (!raw) return null;
		const {data, ts} = JSON.parse(raw);
		if (Date.now() - ts > LANG_CACHE_TTL_MS) {
			localStorage.removeItem(langCacheKey(app));
			return null;
		}
		return data;
	} catch {
		return null;
	}
}

export function writeLangCache(app, data) {
	try {
		localStorage.setItem(langCacheKey(app), JSON.stringify({data, ts: Date.now()}));
	} catch {
		// localStorage full or unavailable — silently skip
	}
}

export default strings;
